import React, { useCallback, useEffect } from "react";
// import "@shopify/polaris/build/esm/styles.css";
import {
  BrowserRouter,
  Routes, // instead of "Switch"
  Route,
} from "react-router-dom";
import { AppProvider, Toast } from "@shopify/polaris";
import "./Assets/Styles/globals.css";
import "./Assets/Styles/react-tagsinput.css";
import Login from "./Pages/Authentication/Login";
import ForgotPassword from "./Pages/Authentication/ForgotPassword";
import Profile from "./Pages/Profile";
import ResetPassword from "./Pages/Authentication/ResetPassword";
import NavigationLayout from "./Components/NavigationLayout";
import "bootstrap/dist/css/bootstrap.css";
import Pages from "./Pages/PagesSection/List";
import AddPage from "./Pages/PagesSection/Add";
import EditPage from "./Pages/PagesSection/Edit";
import Languages from "./Settings/Languages";
import UsersAndPermissions from "./Settings/UsersAndPermissions";
import ContactInformation from "./Settings/ContactInformation";
import AccessPassword from "./Settings/AccessPassword";
import Brand from "./Settings/Brand";
import Sections from "./Pages/PagesSection/Sections";
import Translations from "./Pages/UIText/Translations";
import Dashboard from "./Pages/Dashboard";
import GridView from "./Settings/Integrations/Grid";
import ShopifyDomain from "./Settings/Integrations/ShopifyDomain";
import GoogleAnalytics from "./Settings/Integrations/GoogleAnalytics";
import Navigation from "./Pages/Navigation/Navigation";
import AddMenu from "./Pages/Navigation/AddMenu";
import EditMenu from "./Pages/Navigation/EditMenu";
import Channels from "./Settings/Channels";
import Contacts from "./Pages/CRM/Contacts/List";
import ContactDetails from "./Pages/CRM/Contacts/ContactDetails";
import Companies from "./Pages/CRM/Companies/List";
import { AddContact } from "./Pages/CRM/Contacts/AddContact";
import Categories from "./Pages/CRM/Categories/List";
import Statuses from "./Pages/CRM/Statuses/List";
import { EditContact } from "./Pages/CRM/Contacts/EditContact";
import Campaigns from "./Pages/CRM/Campaigns/List";
import Board from "./Pages/CRM/Board";
import Bookmarks from "./Settings/Bookmarks";
import SectionsCustomization from "./Settings/SectionsCustomization";
import Templates from "./Settings/Templates";
import Deals from "./Pages/CRM/Deals/List";
import { AddDeal } from "./Pages/CRM/Deals/AddDeal";
import DealStages from "./Pages/CRM/DealStages/List";
import DealsBoard from "./Pages/CRM/Deals/Board";
import { EditDeal } from "./Pages/CRM/Deals/EditDeal";
import Projects from "./Pages/Projects/List";
import AddEditProject from "./Pages/Projects/AddEdit";
import { AddWorkflow } from "./Pages/CRM/Automation/AddWorkflow";
import Workflows from "./Pages/CRM/Automation/List";
import { EditWorkflow } from "./Pages/CRM/Automation/EditWorkflow";
import AppSettings from "./Settings/AppSettings";
import PagesTags from "./Settings/PagesTags";
import Portfolio from "./Pages/Portfolio/List";
import AddEditPortfolio from "./Pages/Portfolio/AddEdit";
import Gallery from "./Pages/Portfolio/Gallery/List";
import AddEditGallery from "./Pages/Portfolio/Gallery/AddEdit";
import Products from "./Pages/Products/List";
import AddEditProduct from "./Pages/Products/AddEdit";
import CategoriesProducts from "./Pages/Products/Categories/List";
import AddEditCategories from "./Pages/Products/Categories/AddEdit";
import Tags from "./Pages/Products/Tags/List";
import AddEditTag from "./Pages/Products/Tags/AddEdit";
import ProjectsInnovest from "./Pages/ProjectsInnovest/List";
import AddEditProjectInnovest from "./Pages/ProjectsInnovest/AddEdit";
import Countries from "./Pages/Portfolio/Countries/List";
import AddEditCountry from "./Pages/Portfolio/Countries/AddEdit";
import CategoriesPortfolio from "./Pages/Portfolio/Categories/List";
import AddEditCategoryPortfolio from "./Pages/Portfolio/Categories/AddEdit";
import GalleryInnovest from "./Pages/ProjectsInnovest/Gallery/List";
import AddEditGalleryInnovest from "./Pages/ProjectsInnovest/Gallery/AddEdit";
import DeployNetlify from "./Pages/Deploy/DeployNetlify";
import Talent from "./Pages/Mindset/Team/List";
import AddEditTalent from "./Pages/Mindset/Team/AddEdit";
import AddEditCategoriesTalent from "./Pages/Mindset/Team/Categories/AddEdit";
import CategoriesTalent from "./Pages/Mindset/Team/Categories/List";
import TagsTalent from "./Pages/Mindset/Team/Tags/List";
import AddEditTagsTalent from "./Pages/Mindset/Team/Tags/AddEdit";
import OtpActivities from "./Pages/OTPActivities/List";
import ProjectsMindset from "./Pages/Mindset/Projects/List";
import AddEditProjectMindset from "./Pages/Mindset/Projects/AddEdit";
import TagsProjects from "./Pages/Mindset/Projects/Tags/List";
import AddEditTagsProjects from "./Pages/Mindset/Projects/Tags/AddEdit";
import UpdatesProject from "./Pages/Mindset/Projects/Updates/List";
import AddEditUpdatesProject from "./Pages/Mindset/Projects/Updates/AddEdit";
import ImagesProjects from "./Pages/Mindset/Projects/Images/List";
import AddEditImageProjects from "./Pages/Mindset/Projects/Images/AddEdit";
import CategoriesProjectMindset from "./Pages/Mindset/Projects/Categories/List";
import AddEditCategoryMindsetProject from "./Pages/Mindset/Projects/Categories/AddEdit";
import BrandsCaseStudy from "./Pages/Webedia/CaseStudies/Brands/List";
import AddEditBrandCaseStudy from "./Pages/Webedia/CaseStudies/Brands/AddEdit";
import CaseStudies from "./Pages/Webedia/CaseStudies/List";
import AddEditCaseStudy from "./Pages/Webedia/CaseStudies/AddEdit";
import Awards from "./Pages/Webedia/Awards/List";
import AddEditAward from "./Pages/Webedia/Awards/AddEdit";
import SectorsProjectMindset from "./Pages/Mindset/Projects/Sectors/List";
import AddEditSectorMindsetProject from "./Pages/Mindset/Projects/Sectors/AddEdit";
import GiftRules from "./Pages/GiftRules/List";
import AddEditGiftRule from "./Pages/GiftRules/AddEdit";

function getFaviconEl() {
  return document.getElementById("favicon");
}

function App() {
  if (process.env.NODE_ENV === "production") {
    console.log = function () {};
  }
  useEffect(() => {
    document.title = `${process.env.REACT_APP_CLIENT_NAME} - Admin Panel`;
    const favicon = getFaviconEl();
    favicon.href = `${process.env.REACT_APP_CLIENT_NAME}-favicon.ico`;
  }, []);
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/forgotpassword" element={<ForgotPassword />} />
      <Route path="/password/reset" element={<ResetPassword />} />
      <Route
        path="/admin/settings/social-media-and-links"
        element={
          <NavigationLayout>
            <Translations
              type="social"
              title="Social Media and Links"
              tableTitle1="Name"
              tableTitle2="Url"
              url="settings/social"
            />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/settings/languages"
        element={
          <NavigationLayout>
            <Languages />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/settings/channels"
        element={
          <NavigationLayout>
            <Channels />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/settings/pages-tags"
        element={
          <NavigationLayout>
            <PagesTags />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/settings/templates"
        element={
          <NavigationLayout>
            <Templates />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/settings/bookmarks"
        element={
          <NavigationLayout>
            <Bookmarks />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/settings/users-and-permissions"
        element={
          <NavigationLayout>
            <UsersAndPermissions />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/settings/brand"
        element={
          <NavigationLayout>
            <Brand />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/settings/contact-information"
        element={
          <NavigationLayout>
            <ContactInformation />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/settings/google-analytics-account"
        element={
          <NavigationLayout>
            <GoogleAnalytics />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/settings/access-password"
        element={
          <NavigationLayout>
            <AccessPassword />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/ui-text"
        element={
          <NavigationLayout>
            <Translations
              type="ui"
              title="UI Text"
              tableTitle1="Key"
              tableTitle2="Value"
              url="translations"
            />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/pages"
        element={
          <NavigationLayout>
            <Pages key="pages" type="pages" title="Pages" button="Add Page" />
          </NavigationLayout>
        }
      />

      <Route
        path="/admin/pages/new"
        element={
          <NavigationLayout>
            <AddPage type="pages" title="Add Page" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/pages/:id"
        element={
          <NavigationLayout>
            <EditPage type="pages" title="Edit Page" />
          </NavigationLayout>
        }
      />

      <Route
        path="/admin/blogs"
        element={
          <NavigationLayout>
            <Pages key="blogs" type="blogs" title="Blogs" button="Add Blog" />
          </NavigationLayout>
        }
      />

      <Route
        path="/admin/blogs/new"
        element={
          <NavigationLayout>
            <AddPage type="blogs" title="Add Blog" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/blogs/:id"
        element={
          <NavigationLayout>
            <EditPage type="blogs" title="Edit Blog" />
          </NavigationLayout>
        }
      />

      <Route
        path="/admin/careers"
        element={
          <NavigationLayout>
            <Pages
              key="careers"
              type="careers"
              title="Careers"
              button="Add Career"
            />
          </NavigationLayout>
        }
      />

      <Route
        path="/admin/careers/new"
        element={
          <NavigationLayout>
            <AddPage type="careers" title="Add Career" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/careers/:id"
        element={
          <NavigationLayout>
            <EditPage type="careers" title="Edit Career" />
          </NavigationLayout>
        }
      />

      <Route
        path="/admin/pages/:id/sections"
        element={
          <NavigationLayout>
            <Sections type="pages" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/blogs/:id/sections"
        element={
          <NavigationLayout>
            <Sections type="blogs" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/careers/:id/sections"
        element={
          <NavigationLayout>
            <Sections type="careers" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/dashboard"
        element={
          <NavigationLayout>
            <Dashboard />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/settings/integrations"
        element={
          <NavigationLayout>
            <GridView />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/settings/integrations/shopify-domain"
        element={
          <NavigationLayout>
            <ShopifyDomain />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/settings/integrations/google-analytics"
        element={
          <NavigationLayout>
            <GoogleAnalytics />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/settings/sections-customization"
        element={
          <NavigationLayout>
            <SectionsCustomization />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/navigation"
        element={
          <NavigationLayout>
            <Navigation />
          </NavigationLayout>
        }
      />

      <Route
        path="/admin/navigation/add-menu"
        element={
          <NavigationLayout>
            <AddMenu />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/navigation/:id"
        element={
          <NavigationLayout>
            <EditMenu />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/crm/contacts"
        element={
          <NavigationLayout>
            <Contacts />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/crm/contacts/:id"
        element={
          <NavigationLayout>
            <EditContact />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/crm/deals"
        element={
          <NavigationLayout>
            <Deals />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/crm/deals/stages"
        element={
          <NavigationLayout>
            <DealStages />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/crm/deals/board"
        element={
          <NavigationLayout>
            <DealsBoard />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/crm/deals/:id"
        element={
          <NavigationLayout>
            <EditDeal />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/crm/deals/new"
        element={
          <NavigationLayout>
            <AddDeal />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/crm/contacts/categories"
        element={
          <NavigationLayout>
            <Categories />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/crm/tags"
        element={
          <NavigationLayout>
            <Contacts />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/crm/contacts/statuses"
        element={
          <NavigationLayout>
            <Statuses />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/crm/contacts/:id"
        element={
          <NavigationLayout>
            <ContactDetails />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/crm/contacts/new"
        element={
          <NavigationLayout>
            <AddContact />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/crm/contacts/companies"
        element={
          <NavigationLayout>
            <Companies />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/crm/campaigns"
        element={
          <NavigationLayout>
            <Campaigns />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/crm/contacts/board"
        element={
          <NavigationLayout>
            <Board />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/projects"
        element={
          <NavigationLayout>
            <Projects />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/projects/new"
        element={
          <NavigationLayout>
            <AddEditProject type="add" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/projects/:id"
        element={
          <NavigationLayout>
            <AddEditProject type="edit" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/portfolio/countries"
        element={
          <NavigationLayout>
            <Countries />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/portfolio/countries/new"
        element={
          <NavigationLayout>
            <AddEditCountry type="add" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/portfolio/countries/:countryId"
        element={
          <NavigationLayout>
            <AddEditCountry type="edit" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/portfolio/categories"
        element={
          <NavigationLayout>
            <CategoriesPortfolio />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/portfolio/categories/new"
        element={
          <NavigationLayout>
            <AddEditCategoryPortfolio type="add" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/portfolio/categories/:categoryId"
        element={
          <NavigationLayout>
            <AddEditCategoryPortfolio type="edit" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/projects-innovest"
        element={
          <NavigationLayout>
            <ProjectsInnovest />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/projects-innovest/new"
        element={
          <NavigationLayout>
            <AddEditProjectInnovest type="add" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/projects-innovest/:id"
        element={
          <NavigationLayout>
            <AddEditProjectInnovest type="edit" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/projects-innovest/:id/gallery"
        element={
          <NavigationLayout>
            <GalleryInnovest />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/projects-innovest/:id/gallery/new"
        element={
          <NavigationLayout>
            <AddEditGalleryInnovest type="add" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/projects-innovest/:id/gallery/:galleryId"
        element={
          <NavigationLayout>
            <AddEditGalleryInnovest type="edit" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/portfolio"
        element={
          <NavigationLayout>
            <Portfolio />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/portfolio/new"
        element={
          <NavigationLayout>
            <AddEditPortfolio type="add" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/portfolio/:id"
        element={
          <NavigationLayout>
            <AddEditPortfolio type="edit" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/portfolio/:id/gallery"
        element={
          <NavigationLayout>
            <Gallery />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/portfolio/:id/gallery/new"
        element={
          <NavigationLayout>
            <AddEditGallery type="add" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/portfolio/:id/gallery/:galleryId"
        element={
          <NavigationLayout>
            <AddEditGallery type="edit" />
          </NavigationLayout>
        }
      />

      <Route
        path="/admin/products"
        element={
          <NavigationLayout>
            <Products />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/products/new"
        element={
          <NavigationLayout>
            <AddEditProduct type="add" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/products/:id"
        element={
          <NavigationLayout>
            <AddEditProduct type="edit" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/products/categories"
        element={
          <NavigationLayout>
            <CategoriesProducts />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/products/categories/new"
        element={
          <NavigationLayout>
            <AddEditCategories type="add" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/products/categories/:id"
        element={
          <NavigationLayout>
            <AddEditCategories type="edit" />
          </NavigationLayout>
        }
      />

      <Route
        path="/admin/products/tags"
        element={
          <NavigationLayout>
            <Tags />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/products/tags/new"
        element={
          <NavigationLayout>
            <AddEditTag type="add" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/products/tags/:id"
        element={
          <NavigationLayout>
            <AddEditTag type="edit" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/crm/automation"
        element={
          <NavigationLayout>
            <Workflows />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/crm/automation/new"
        element={
          <NavigationLayout>
            <AddWorkflow />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/crm/automation/:id"
        element={
          <NavigationLayout>
            <EditWorkflow />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/settings/app-settings"
        element={
          <NavigationLayout>
            <AppSettings />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/settings/deploy"
        element={
          <NavigationLayout>
            <DeployNetlify />
          </NavigationLayout>
        }
      />

      <Route
        path="/admin/talent"
        element={
          <NavigationLayout>
            <Talent />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/talent/new"
        element={
          <NavigationLayout>
            <AddEditTalent type="add" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/talent/:id"
        element={
          <NavigationLayout>
            <AddEditTalent type="edit" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/talent/categories"
        element={
          <NavigationLayout>
            <CategoriesTalent />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/talent/categories/new"
        element={
          <NavigationLayout>
            <AddEditCategoriesTalent type="add" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/talent/categories/:id"
        element={
          <NavigationLayout>
            <AddEditCategoriesTalent type="edit" />
          </NavigationLayout>
        }
      />

      <Route
        path="/admin/talent/tags"
        element={
          <NavigationLayout>
            <TagsTalent />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/talent/tags/new"
        element={
          <NavigationLayout>
            <AddEditTagsTalent type="add" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/talent/tags/:id"
        element={
          <NavigationLayout>
            <AddEditTagsTalent type="edit" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/otp-activities"
        element={
          <NavigationLayout>
            <OtpActivities />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/projects-mindset"
        element={
          <NavigationLayout>
            <ProjectsMindset />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/projects-mindset/new"
        element={
          <NavigationLayout>
            <AddEditProjectMindset mode="new" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/projects-mindset/:id"
        element={
          <NavigationLayout>
            <AddEditProjectMindset mode="edit" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/projects-mindset/facilities"
        element={
          <NavigationLayout>
            <TagsProjects />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/projects-mindset/facilities/new"
        element={
          <NavigationLayout>
            <AddEditTagsProjects type="add" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/projects-mindset/facilities/:id"
        element={
          <NavigationLayout>
            <AddEditTagsProjects type="edit" />
          </NavigationLayout>
        }
      />

      <Route
        path="/admin/projects-mindset/categories"
        element={
          <NavigationLayout>
            <CategoriesProjectMindset />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/projects-mindset/categories/new"
        element={
          <NavigationLayout>
            <AddEditCategoryMindsetProject type="add" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/projects-mindset/categories/:id"
        element={
          <NavigationLayout>
            <AddEditCategoryMindsetProject type="edit" />
          </NavigationLayout>
        }
      />

      <Route
        path="/admin/projects-mindset/sectors"
        element={
          <NavigationLayout>
            <SectorsProjectMindset />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/projects-mindset/sectors/new"
        element={
          <NavigationLayout>
            <AddEditSectorMindsetProject type="add" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/projects-mindset/sectors/:id"
        element={
          <NavigationLayout>
            <AddEditSectorMindsetProject type="edit" />
          </NavigationLayout>
        }
      />

      <Route
        path="/admin/projects-mindset/:id/updates"
        element={
          <NavigationLayout>
            <UpdatesProject />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/projects-mindset/:id/updates/new"
        element={
          <NavigationLayout>
            <AddEditUpdatesProject type="add" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/projects-mindset/:id/updates/:itemId"
        element={
          <NavigationLayout>
            <AddEditUpdatesProject type="edit" />
          </NavigationLayout>
        }
      />

      <Route
        path="/admin/projects-mindset/:id/images"
        element={
          <NavigationLayout>
            <ImagesProjects />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/projects-mindset/:id/images/new"
        element={
          <NavigationLayout>
            <AddEditImageProjects mode="new" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/projects-mindset/:id/images/:itemId"
        element={
          <NavigationLayout>
            <AddEditImageProjects mode="edit" />
          </NavigationLayout>
        }
      />

      <Route
        path="/admin/case-studies/brands"
        element={
          <NavigationLayout>
            <BrandsCaseStudy />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/case-studies/brands/new"
        element={
          <NavigationLayout>
            <AddEditBrandCaseStudy type="add" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/case-studies/brands/:id"
        element={
          <NavigationLayout>
            <AddEditBrandCaseStudy type="edit" />
          </NavigationLayout>
        }
      />

      <Route
        path="/admin/case-studies"
        element={
          <NavigationLayout>
            <CaseStudies />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/case-studies/new"
        element={
          <NavigationLayout>
            <AddEditCaseStudy mode="new" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/case-studies/:id"
        element={
          <NavigationLayout>
            <AddEditCaseStudy mode="edit" />
          </NavigationLayout>
        }
      />

      <Route
        path="/admin/awards"
        element={
          <NavigationLayout>
            <Awards />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/awards/new"
        element={
          <NavigationLayout>
            <AddEditAward mode="new" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/awards/:id"
        element={
          <NavigationLayout>
            <AddEditAward mode="edit" />
          </NavigationLayout>
        }
      />

      <Route
        path="/admin/settings/gift-rules"
        element={
          <NavigationLayout>
            <GiftRules />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/settings/gift-rules/new"
        element={
          <NavigationLayout>
            <AddEditGiftRule mode="new" />
          </NavigationLayout>
        }
      />
      <Route
        path="/admin/settings/gift-rules/:id"
        element={
          <NavigationLayout>
            <AddEditGiftRule mode="edit" />
          </NavigationLayout>
        }
      />
    </Routes>
  );
}
export default App;
